export class ApiError<T> extends Error {
  options?: T;

  constructor(message: string, options?: T) {
    super(message);
    this.options = options;
  }
}

export const apiErrorMessage = (error: any) => {
  if (error.response && error.response.data) {
    console.log("Error response data:", error.response.data);
    
    // Check if the error contains an array of messages
    if (Array.isArray(error.response.data.error)) {
      const joinedErrorMessage = error.response.data.error.join(', ');  // Join messages with a comma and space
      throw new Error(joinedErrorMessage);
    }

    // If not an array, throw the error message directly
    throw new Error(error.response.data.error || 'An unexpected error occurred');
  } else if (error.request) {
    // If no response is received from the server
    throw new Error('No response received from server');
  } else {
    // For other errors
    throw new Error(error.message || 'An unexpected error occurred');
  }
};
